export const resendEmail = async (
  email_from_name,
  email_from_address,
  received_header,
  email_body,
  job_name,
  voicemail,
) => {
  const options = {
    method: "POST",
    body: JSON.stringify({
      email_from_name,
      email_from_address,
      received_header,
      email_body,
      job_name,
      voicemail,
    }),
    headers: {
      "Content-Type": "application/json",
      Authorization: `Basic ${process.env.REACT_APP_AWS_USER_TOKEN}`,
    },
  };

  let response = {};

  const processExe = () => {
    return new Promise((resolve, reject) => {
      fetch(`${process.env.REACT_APP_AWS_USER_ENDPOINT}/resend-email`, options)
        .then((resp) => resp.json())
        .then((data) => {
          response = { ...data };
          resolve(response);
        })
        .catch((error) => {
          response = {
            status: 500,
            message: `Error in resending email: [${error.message}]`,
          };
          reject(response);
        });
    });
  };

  await processExe();
  return response;
};
